// Base URL configuration with runtime env support
import { AppConfigService } from "./config";

export const getBaseUrl = (): string => {
  // 1. 优先使用运行时配置（window.__APP_CONFIG__）
  const configured = AppConfigService.getString("VITE_API_URL");
  if (configured) {
    return configured;
  }

  // 2. 开发环境检测
  if (isDevMode()) {
    return "http://localhost:8040";
  }

  // 3. 浏览器端：尝试从构建时环境变量获取（仅作为 fallback）
  if (typeof window !== "undefined") {
    if (import.meta.env.VITE_API_URL) {
      return import.meta.env.VITE_API_URL;
    }
    // 如果都没有配置，则根据当前访问域名自动推断
    const { hostname, protocol } = window.location;
    const inferred = `${protocol}//${hostname}/api`;
    return inferred;
  }

  // 4. 服务器端（SSR）：仅在明确配置时使用
  if (
    import.meta.env.VITE_API_URL &&
    import.meta.env.VITE_API_URL.startsWith("http")
  ) {
    return import.meta.env.VITE_API_URL;
  }

  // 服务器端默认返回
  return "http://localhost:8040";
};

export const getBaseURL = () => getBaseUrl();

export function isDevMode(): boolean {
  // 环境变量强制指定时，直接返回
  const runtimeEnv =
    import.meta.env.VITE_PUBLIC_ENV || import.meta.env.NODE_ENV;
  if (runtimeEnv && runtimeEnv !== "development") {
    return false;
  }

  // 服务器端渲染环境中，根据 NODE_ENV 判断
  if (typeof window === "undefined") {
    return import.meta.env.NODE_ENV === "development";
  }

  // 客户端根据 hostname 判断
  const hostname: string = window.location.hostname;
  return (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname.startsWith("192.") ||
    hostname.startsWith("172.")
  );
}
